// extracted by mini-css-extract-plugin
export default {"categories":"style_categories__eFdyQ","item":"style_item__AnS0w","active":"style_active__Stno6"};